// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"mB","blender_bottle_img":"nB","blender_bottle_info":"oB","blender_bottle_title":"pB","blender_bottle_bold":"qB","blender_bottle_usual":"rB","blender_bottle_item_mob":"sB","addbutton":"tB","blender_bottle_title_mob":"uB","blender_bottle_bold_mob":"vB","blender_bottle_usual_mob":"wB","bolder":"xB","bottom_margin_4":"yB","bottom_margin_16":"zB"};
    if(module.hot) {
      // 1713912565877
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  